var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-dollar","titulo":"PAGAMENTOS SGF"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Credenciados_Finalizacoes' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }